module.exports = __webpack_public_path__ + "img/Training-Hover.9525f0f5.svg";